import { LaunchSoonActionTypes, ProcessPreProcessRegistrationActionInterface } from './contracts/actionTypes';
import { LaunchSoonPayload } from './contracts/state';

export const preProcessRequests = (payload: LaunchSoonPayload): ProcessPreProcessRegistrationActionInterface => ({
    type: LaunchSoonActionTypes.PROCESS_PRE_PROCESS_REGISTRATION,
    payload
});